/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsClearingV1SweepsTaskState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_CLEARING_V1_SWEEPS_TASK_STATE_ENTITY_NAME = 'ixc.sweeps.clearing.v1.SweepsTask';
export const ixcSweepsClearingV1SweepsTaskStateEntity = new schema.Entity<IxcSweepsClearingV1SweepsTaskState>(IXC_SWEEPS_CLEARING_V1_SWEEPS_TASK_STATE_ENTITY_NAME, {}, { idAttribute: 'sweepsTaskId' });

